import { inject, NewInstance } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { AssignedProjectService } from 'pages/daiatari/assigned-projects/service';
import { SnapshotTypeService } from 'pages/system-fields/snapshot-types/service';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';

@inject(DialogController, NewInstance.of(ValidationController), AssignedProjectService, SnapshotTypeService)
export class BulkSnapshot {
    constructor(dialogController, validationController, assignedProjectService, snapshotTypeService) {
        this.dialogController = dialogController;
        this.assignedProjectService = assignedProjectService;
        this.snapshotTypeService = snapshotTypeService;

        this.snapshot = {
            assignedProjectId: null,
            productionType: null,
            snapshotTypeId: null,
            effectiveDate: null,
            description: null
        }
        
        this.rules = ValidationRules
            .ensure('assignedProjectId').required()
            .ensure('productionType').required()
            .ensure('snapshotTypeId').required()
            .rules;
        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
    }

    async save() {
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            this.dialogController.ok(this.snapshot);
        }
    }
}